export default "__VITE_ASSET__DeM$6iq3__"